import React, { useState, useEffect } from "react";
import { get, isEmpty } from "lodash";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/pro-light-svg-icons";
import { getPathWithParam, FLOW_TYPES } from "../../utils";
import tenantConfig from "../../mocks/tenantOne.json";
import permissions from "../../mocks/menuPermissions.json";
import authService from "../api-authorization/AuthorizeService";

const ManageMapperMenu = ({
  menuList = [],
  flow,
  selectedMenu,
  profileId,
  linkDisable,
  isFixedLength,
  mapType,
  isOutput,
  mapName,
  fileName,
  mappingObjectMaps,
}) => {
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };

  const checkOutputDisable = (id) => {
    switch (linkDisable) {
      case 0:
        return ["loadDefinitionHome", "targetOutput"].includes(id);
      case 1:
        return [
          "loadDefinitionHome",
          "targetOutput",
          "mapAndTransform",
        ].includes(id);
    }
    if (linkDisable >= 2) return true;
  };

  const checkInputDisable = (id) => {
    switch (linkDisable) {
      case 0:
        return ["loadDefinitionHome", "loadDefinitionSource"].includes(id);
      case 1:
        return isFixedLength
          ? [
              "loadDefinitionHome",
              "loadDefinitionSource",
              "fixedLength",
            ].includes(id)
          : [
              "loadDefinitionHome",
              "loadDefinitionSource",
              "targetContainers",
            ].includes(id);
      case 2:
        return [
          "loadDefinitionHome",
          "loadDefinitionSource",
          "fixedLength",
          "targetContainers",
        ];
      case 3:
        return [
          "loadDefinitionHome",
          "loadDefinitionSource",
          "fixedLength",
          "targetContainers",
          "mapAndTransform",
        ].includes(id);
    }
    if (linkDisable >= 4) return true;
  };

  const checkPassthroughDisable = (id) => {
    switch (linkDisable) {
      case 0:
        return ["loadDefinitionHome", "loadDefinitionSource"].includes(id);
      case 1:
        return isFixedLength
          ? [
              "loadDefinitionHome",
              "loadDefinitionSource",
              "preview",
              "fixedLength",
            ].includes(id)
          : ["loadDefinitionHome", "loadDefinitionSource", "preview"].includes(
              id
            );
      case 2:
        return [
          "loadDefinitionHome",
          "loadDefinitionSource",
          "preview",
          "targetContainers",
        ].includes(id);
      case 3:
        return [
          "loadDefinitionHome",
          "loadDefinitionSource",
          "fixedLength",
          "preview",
          "targetContainers",
          "mapAndTransform",
        ].includes(id);
      case 4:
        return [
          "loadDefinitionHome",
          "loadDefinitionSource",
          "fixedLength",
          "preview",
          "targetContainers",
          "mapAndTransform",
          "validations",
          "verifyMap",
          "loadFilter",
          "aggregate",
          "split",
        ].includes(id);
      case 5:
        return [
          "loadDefinitionHome",
          "loadDefinitionSource",
          "fixedLength",
          "preview",
          "targetContainers",
          "mapAndTransform",
          "validations",
          "verifyMap",
          "loadFilter",
          "aggregate",
          "split",
        ].includes(id);
    }
    if (linkDisable >= 6) return true;
  };

  const enableInputGreenTick = (id) => {
    switch (linkDisable) {
      case 0:
        return ["loadDefinitionHome"].includes(id);
      case 1:
        return ["loadDefinitionHome", "loadDefinitionSource"].includes(id);
      case 2:
        return [
          "loadDefinitionHome",
          "loadDefinitionSource",
          "fixedLength",
        ].includes(id);
      case 3:
        return [
          "loadDefinitionHome",
          "loadDefinitionSource",
          "fixedLength",
          "targetContainers",
        ].includes(id);
      case 4:
        return [
          "loadDefinitionHome",
          "loadDefinitionSource",
          "fixedLength",
          "targetContainers",
          "mapAndTransform",
          "verifyMap",
        ].includes(id);
      case 5:
        return [
          "loadDefinitionHome",
          "loadDefinitionSource",
          "fixedLength",
          "targetContainers",
          "mapAndTransform",
          "verifyMap",
          "loadFilter",
        ].includes(id);
      case 6:
        return [
          "loadDefinitionHome",
          "loadDefinitionSource",
          "fixedLength",
          "targetContainers",
          "mapAndTransform",
          "verifyMap",
          "loadFilter",
          "aggregate",
          "split",
        ].includes(id);
      case 7:
        return [
          "loadDefinitionHome",
          "loadDefinitionSource",
          "fixedLength",
          "targetContainers",
          "mapAndTransform",
          "verifyMap",
          "loadFilter",
          "aggregate",
          "ruleset",
          "split",
        ].includes(id);
      case 8:
        return true;
    }
  };

  const enablePassthroughGreenTick = (id) => {
    switch (linkDisable) {
      case 0:
        return ["loadDefinitionHome"].includes(id);
      case 1:
        return ["loadDefinitionHome", "loadDefinitionSource"].includes(id);
      case 2:
        return [
          "loadDefinitionHome",
          "loadDefinitionSource",
          "fixedLength",
          "preview",
        ].includes(id);
      case 3:
        return [
          "loadDefinitionHome",
          "loadDefinitionSource",
          "fixedLength",
          "preview",
          "targetContainers",
        ].includes(id);
      case 4:
        return [
          "loadDefinitionHome",
          "loadDefinitionSource",
          "fixedLength",
          "preview",
          "targetContainers",
          "mapAndTransform",
        ].includes(id);
      case 5:
        return [
          "loadDefinitionHome",
          "loadDefinitionSource",
          "fixedLength",
          "preview",
          "targetContainers",
          "mapAndTransform",
          "validations",
          "verifyMap",
        ].includes(id);
      case 6:
        return [
          "loadDefinitionHome",
          "loadDefinitionSource",
          "fixedLength",
          "preview",
          "targetContainers",
          "mapAndTransform",
          "validations",
          "verifyMap",
          "loadFilter",
        ].includes(id);
      case 7:
        return [
          "loadDefinitionHome",
          "loadDefinitionSource",
          "fixedLength",
          "preview",
          "targetContainers",
          "mapAndTransform",
          "validations",
          "verifyMap",
          "loadFilter",
          "aggregate",
          "ruleset",
          "split",
        ].includes(id);
      case 8:
        return true;
    }
  };
  const enableOutputGreenTick = (id) => {
    switch (linkDisable) {
      case 0:
        return ["loadDefinitionHome"].includes(id);
      case 1:
        return ["loadDefinitionHome", "targetOutput"].includes(id);
      case 2:
        return [
          "loadDefinitionHome",
          "targetOutput",
          "mapAndTransform",
          "verifyMap",
        ].includes(id);
      case 3:
        return true;
    }
  };

  return (
    <ul className="manage-mapper-menu">
      {menuList?.map((item) => {
        const childRoutes = get(item, "childRoutes", []);
        let className =
          selectedMenu.indexOf(item.path) !== -1 ||
          childRoutes.filter((route) => {
            return selectedMenu.indexOf(route) !== -1;
          }).length
            ? "selected"
            : "";

        let enable = false;
        let greenTickEnable = "";
        if (item.id == "overview") enable = greenTickEnable = true;
        else if (mapType == 1 && isOutput)
          enable = item.id == "loadDefinitionHome";
        else
          switch (mapType) {
            case 1:
              enable = checkInputDisable(item.id);
              greenTickEnable = enableInputGreenTick(item.id);
              break;
            case 2:
              enable = checkOutputDisable(item.id);
              greenTickEnable = enableOutputGreenTick(item.id);
              break;
            case 3:
              enable = checkPassthroughDisable(item.id);
              greenTickEnable = enablePassthroughGreenTick(item.id);
              break;
            default:
              enable = item.id == "loadDefinitionHome";
          }

        if (!isFixedLength && item.label == "File Specifications") {
          return <></>;
        }

        return (
          tenantConfig?.mapperSubMenu?.includes(item.id) &&
          permissions[roleName]?.mapperSubMenu[item.id] && (
            <li
              key={item.path}
              className={
                !enable
                  ? "disabled has-tick"
                  : `${className} ${greenTickEnable ? "done" : ""} has-tick`
              }
            >
              <FontAwesomeIcon
                icon={faCheckCircle}
                size="1x"
                // style={{
                //   color:
                //     (mapName && item.id == "loadDefinitionHome") ||
                //     (fileName && item.id == "targetOutput") ||
                //     (mappingObjectMaps && item.id == "mapAndTransform") ||
                //     (mappingObjectMaps && item.id == "verifyMap") ||
                //     (mapName && item.id == "overview")
                //       ? "green"
                //       : "grey",
                // }}
              />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <Link
                disabled={!enable}
                to={getPathWithParam({
                  path: item.path,
                  pathParam: [flow, mapType, profileId],
                })}
              >
                {item.label}
              </Link>
              {/* <span className="open-rounded-corner-top" />
              <span className="open-rounded-corner-bottom" /> */}
            </li>
          )
        );
      })}
    </ul>
  );
};

export default ManageMapperMenu;
